module.exports = __webpack_public_path__ + "static/media/Bathroom Tub Towel.7ff0d40f.svg";